import React from 'react';
import {NavLink, Outlet} from 'react-router-dom';
import {useDocumentTitle} from '../../hooks/useDocumentTitle';

const TABS = [
    {to: 'info',        label: 'Инфо'},
    {to: 'ai',          label: 'AI'},
    {to: 'preferences', label: 'Предпочтения'},
    {to: 'access',      label: 'Доступ'},
    {to: 'security',    label: 'Безопасность'},
    {to: 'api-keys',    label: 'Ключи API'},
    {to: 'background-tasks', label: 'Фоновые задачи'},
    {to: 'privacy',     label: 'Данные'},
];

const tabBase = 'py-2 px-1 border-b-2 font-medium text-sm whitespace-nowrap transition-colors';
const tabActive = 'border-primary-500 text-primary-600 dark:text-primary-400';
const tabInactive = 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-300';

const ProfileLayout: React.FC = () => {
    useDocumentTitle('Настройки профиля');
    return (
        <div className="max-w-[1040px] mx-auto" data-testid="profile-page">
            <div className="mb-6">
                <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">Настройки профиля</h1>
            </div>

            <div className="border-b border-gray-200 dark:border-gray-700 mb-6">
                <nav aria-label="Разделы настроек профиля" data-testid="profile-tabs"
                     className="-mb-px flex gap-6 overflow-x-auto no-scrollbar">
                    {TABS.map(tab => (
                        <NavLink
                            key={tab.to}
                            to={tab.to}
                            data-testid={`profile-tab-${tab.to}`}
                            className={({isActive}) => `${tabBase} ${isActive ? tabActive : tabInactive}`}
                        >
                            {tab.label}
                        </NavLink>
                    ))}
                </nav>
            </div>

            <Outlet/>
        </div>
    );
};

export default ProfileLayout;
